import store from '@/store'

export default [
  {
    path: '/admin/news',
    name: 'news',
    meta: { requiresAuth: true },
    component: () => import('@/pages/administrator/news')
  },
  {
    path: '/admin/news/create',
    name: 'news-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/administrator/news/create.vue')
  },
  {
    path: '/admin/news/:id/edit',
    name: 'news-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/administrator/news/edit.vue')
  }
]
